import { Pipe, PipeTransform } from '@angular/core';
import { compare } from '../utils/sort';

/**
 * Sorts a generic collection by a given column name ascending or descending.
 */
@Pipe({
    name: 'sortBy',
    standalone: false,
})
export class SortByPipe implements PipeTransform {
    transform<TData>(
        collection: TData[],
        column: string,
        ascending: boolean,
    ): TData[] {
        return collection.sort((first, second) => {
            const firstVal = first[column as keyof TData];
            const secondVal = second[column as keyof TData];
            return compare(firstVal, secondVal, ascending);
        });
    }
}
